<template>
  <div class="projects-container">
    <div class="content-wrapper">
      <div class="content-box">
        <p>{{ pageContent }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: `Too little perseverance.
Working on it.`,
    }
  },
  computed: {
    pageContent() {
      return this.content;
    }
  }
};
</script>

<style scoped>
.projects-container {
  min-height: calc(100vh - 6rem);
  background-color: #fafafa;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  padding-top: 6rem;
}

.content-wrapper {
  max-width: 65ch;
  width: 100%;
  padding: 4rem 2rem;
  animation: fadeIn 0.8s ease-out;
}

.content-box {
  position: relative;
  padding-left: 2rem;
  border-left: 1px solid #ddd;
}

p {
  font-family: 'Inter', sans-serif;
  font-size: 1.125rem;
  line-height: 1.75;
  color: #404040;
  white-space: pre-wrap;
  margin: 0;
  font-weight: 300;
  letter-spacing: 0.01em;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 2rem 1rem;
  }
  
  .content-box {
    padding-left: 1rem;
  }
  
  p {
    font-size: 1rem;
  }
}
</style>
  